//
// ドロップダウンメニューに対する制御
//
document.addEventListener("DOMContentLoaded", (_event) => {
  const menuElements = document.querySelectorAll("[data-dropdown-menu]");
  if (menuElements.length == 0) return;

  // メニュー以外をクリックした場合はメニューを閉じる
  document.addEventListener("click", (e) => {
    const target = e.target;
    const checked = document.querySelector(
      "[data-dropdown-menu] input[type='checkbox']:checked"
    );

    if (!checked) {
      return;
    }

    const isMenuIcon =
      target.id === checked.id || target.getAttribute("for") === checked.id;

    if (!(isMenuIcon || target.closest(`#${checked.id}`))) {
      checked.checked = false;
    }
  });
});
